/// <reference lib="dom" />

import api from '@/api/axios';
import moment from 'moment';

export const getSentencesetsResultsTimeSeries = (
  setId: string,
  duration: number,
) => {
  return api
    .get(`/api/patients/sentencesets/${setId}/resultstimeseries${duration}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getWordsetsResultsTimeSeries = (
  setId: string,
  duration: number,
) => {
  return api
    .get(`/api/patients/wordsets/${setId}/resultstimeseries${duration}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getIndividualSentenceStats = (setId: string, duration: number) => {
  return api
    .get(
      `/api/patients/sentencesets/${setId}/individualsentencestats${duration}`,
    )
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const getIndividualWordStats = (setId: string, duration: number) => {
  return api
    .get(`/api/patients/wordsets/${setId}/individualwordstats${duration}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const newDownloadResults = async (token: string) => {
  try {
    const { data } = await api.get(
      'api/patients/practicesessions/results/export/bundle',
      {
        headers: {
          Authorization: `JWT ${token}`,
          Accept: 'application/json',
          'Content-type': 'application/json',
        },
      },
    );
    const fileName =
      'neolexon_aphasie-bundle-' + moment().format('DD.MM.YYYY') + '.xml';
    const dataBlob = new Blob([data], { type: 'text/xml' });
    const urlBlob = URL.createObjectURL(dataBlob);
    const aTagForDownload = window.document.createElement('a');
    // automated click for the a tag to download the link
    aTagForDownload.href = urlBlob;
    aTagForDownload.download = fileName;
    aTagForDownload.click();
    aTagForDownload.remove();
  } catch (error) {
    return Promise.reject(error);
  }
};
